<!--网点输入搜索-->
<template>
  <div>
    <el-autocomplete class="inline-input"
                     v-if="show"
                     v-model="buyShopName"
                     :fetch-suggestions="queryBuyShopSearch"
                     placeholder=""
                     :trigger-on-focus="false"
                     @select="handleBuyShopSelect"
                     :clearable="true"
    />
    <el-input v-else size="small" v-model="showBuyShop" :disabled="true"/>
  </div>
</template>

<script>
import api from "@/api/projectApi";

export default {
  name: 'buyShopSearch',
  props: {
    siteId: {
      required: true
    },
    show: {
      default: true
    },
    showBuyShop: {}
  },
  components: {},
  data() {
    return {
      buyShopName: null,
      buyShopId:null,
    }
  },

  watch: {
    buyShopName: {
      handler(newVal) {
        if (newVal == null || newVal == '' || newVal == undefined) {
          this.$emit('update:buyShopName', null)
        }
      },
      deep: true,
      immediate: false,
    },
    buyShopId: {
      handler(newVal) {
        if (newVal == null || newVal == '' || newVal == undefined) {
          this.$emit('update:buyShopId', null)
        }
      },
      deep: true,
      immediate: false,
    }
  },


  methods: {
    // 获取服务商提示
    queryBuyShopSearch(queryStr, callback) {
      this.$mask.open()

      this.$http({
        url: api.basBuyShop.getListUrl,
        method: 'post',
        data: {shopName: queryStr}
      }).then(res => {
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.shopName, id: item.id})
        })
        callback(temp)
      })
      this.$mask.close()

    },

    // 服务商提示选中
    handleBuyShopSelect(data) {
      console.log("更新数据1>>>>",data.value);
      console.log("更新数据2>>>>",data.id);
      this.$emit('update:buyShopName', data.value)
      this.$emit('update:buyShopId', data.id)
    },
  },
};
</script>

<style scoped lang="scss">

</style>
